export const toLegacyGuid = (guid: string): string => {
  if (!guid) return guid;
  return guid.startsWith('{') ? guid : `{${guid.toUpperCase()}}`;
};

export const generateUUID = (): string => {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) {
    return crypto.randomUUID();
  }

  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
};
//This was needed because not all browsers support crypto.randomUUID(). This is a fallback for generating UUIDs which are used to update the test points at runtime in the JSon data structure.
